import { memo } from 'react';

function InfoIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			fill="none"
			viewBox="0 0 18 18"
		>
			<path
				fill="#607EFE"
				fillRule="evenodd"
				d="M17.333 9.087a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0zm-8.334 4.791c.346 0 .625-.28.625-.625v-5a.625.625 0 00-1.25 0v5c0 .346.28.625.625.625zM9 4.92a.833.833 0 110 1.667.833.833 0 010-1.667z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}

export default memo(InfoIcon);
